"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Skeleton = _interopRequireDefault(require("./Skeleton"));
var _default = _Skeleton["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/skeleton/index.js
// module id = 729
// module chunks = 0